'use client';
import { useEffect, useRef } from 'react';
import { elevarBaseData } from '@/lib/elevar/cart-events';
import { elevarPageTypePage } from '@/lib/elevar/page-type';
import { elevarEnsureContext } from '@/lib/elevar/ensure-context';
import { useCart } from '@/contexts/CartContext';
import { usePricing } from '@/contexts/PricingContext';

/**
 * Fires `dl_user_data` then the legacy `pageType: 'page'` push on homepage and CMS pages.
 * Mount with a unique `key` on the route so the ref resets via remount on navigation.
 * The ref is marked immediately before the first event to prevent duplicate pushes
 * while allowing abandoned effects to retry.
 */
export default function ElevarBaseData() {
  const { cart } = useCart();
  const pricing = usePricing();
  const hasFiredRef = useRef(false);

  useEffect(() => {
    if (cart === null || hasFiredRef.current) return;

    let cancelled = false;

    (async () => {
      await elevarEnsureContext();
      if (cancelled) return;

      hasFiredRef.current = true;
      await elevarBaseData(cart, pricing);
      elevarPageTypePage();
    })();

    return () => { cancelled = true; };
  }, [cart]);

  return null;
}
